import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    position: 'fixed',
    maxWidth: 'inherit',
    width: 'inherit',
    zIndex: 1000,
    backgroundColor: (theme) => theme.palette.background.default,
    top: '64px',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  inputs: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
  },
  inputName: { width: '100%' },
  buttons: {
    marginTop: '2rem',
    marginBottom: '4rem',
    width: '100',
    justifyContent: 'flex-end',
    gap: '20px',
    display: 'flex',
  },
  topButtons: {
    justifyContent: 'flex-end',
    gap: 'inherit',
    display: 'flex',
  },
  loadingBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10000,
  },
});

export default useSx;
